import { useState } from "react";
import { Play } from "lucide-react";

function toEmbed(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/))([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}?autoplay=1`;
  const ig = url.match(/instagram\.com\/(?:p|reel|tv)\/([\w-]+)/);
  if (ig) return `https://www.instagram.com/p/${ig[1]}/embed`;
  return url;
}

// Poster with a play button; on click, swaps to an embedded player (if a URL is set).
export const VideoReel = ({ url, poster, label = "SAMPLE REEL", length = "", heightClass = "h-[300px] sm:h-[520px]", dark = false }) => {
  const [playing, setPlaying] = useState(false);
  const embed = toEmbed(url);
  const isInstagram = /instagram\.com/.test(url || "");

  if (playing && embed) {
    if (isInstagram) {
      return (
        <div className="clip-frame overflow-hidden border border-cream/20 bg-forest-deep flex justify-center py-6 px-3">
          <iframe
            data-testid="reel-iframe"
            src={embed}
            title="Sample reel"
            className="w-full max-w-[420px] h-[640px] bg-white rounded-xl"
            frameBorder="0"
            scrolling="no"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
          />
        </div>
      );
    }
    return (
      <div className={`relative clip-frame overflow-hidden border ${dark ? "border-cream/20" : "border-clubborder"}`}>
        <iframe
          data-testid="reel-iframe"
          src={embed}
          title="Sample reel"
          className={`w-full ${heightClass}`}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => embed && setPlaying(true)}
      data-testid="reel-play"
      className={`relative group w-full clip-frame overflow-hidden border ${dark ? "border-cream/20" : "border-clubborder"} ${embed ? "cursor-pointer" : "cursor-default"}`}
    >
      <img src={poster} alt="Sample reel preview" className={`filmed w-full ${heightClass} object-cover`} />
      <span className="absolute inset-0 bg-forest-deep/30 flex items-center justify-center">
        <span className="w-20 h-20 rounded-full bg-cream/95 flex items-center justify-center group-hover:scale-110 transition-transform">
          <Play size={30} className="text-forest ml-1" fill="currentColor" />
        </span>
      </span>
      <span className="absolute top-4 left-4 text-cream/90 text-xs tracking-widest">
        {label}{length ? ` · ${length}` : ""}{!embed ? " · COMING SOON" : ""}
      </span>
    </button>
  );
};
